import { createSelector } from 'reselect';

const selectOpennetworkCategories = (state: any) => state.opennetworkCategories;


export const selectOpennetworkCategoriesCurrentItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.current);

export const selectOpennetworkCategoriesListItems = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.list);

export const selectOpennetworkCategoriesItemById = (itemId: any) =>
    createSelector(selectOpennetworkCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpennetworkCategoryCreatedItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.create);

export const selectOpennetworkCategoryQueryItems = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.query);

export const selectOpennetworkCategoryUpdatedItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.update);

export const selectOpennetworkCategoryReadItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.read);

export const selectOpennetworkCategoryDeletedItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.delete);

export const selectOpennetworkCategoryPublishedItem = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.publish);

export const selectOpennetworkCategorySearchedItems = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.search);

export const selectOpennetworkCategoryItemsCount = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.count);

export const selectOpennetworkCategoryItemsFilter = createSelector([selectOpennetworkCategories], (opennetworkCategories) => opennetworkCategories.filter);